// @flow
import type {Node} from 'react'
import React, {Fragment} from 'react'

import usePersistentState from 'utils/hooks/usePersistentState'
import Section from 'components/SideBar/ui/Section'
import ToggleButton from 'components/SideBar/ui/ToggleButton'

type Props = $ReadOnly<{
  collapsibleSection: boolean,
  id: ?string,
  renderChildren: ?({toggle: () => void}) => Node,
  renderTitle: ?() => Node,
  sectionName: string,
  title: string,
  expandedByDefault: boolean,
}>

function ItemsSection({
  collapsibleSection,
  id,
  renderChildren,
  renderTitle,
  sectionName,
  title,
  expandedByDefault,
}: Props): Node {
  const [isSectionCollapsed, setIsSectionCollapsed]
    = usePersistentState(!expandedByDefault, `sidebar_${sectionName}_collapsed`)

  const onToggleCollapseSection = () => setIsSectionCollapsed(!isSectionCollapsed)

  const toggleCollapseSectionButton = () => (
    <ToggleButton
      isCollapsed={isSectionCollapsed}
      onToggle={onToggleCollapseSection}
    />
  )

  const maybeRenderTitle = () => (
    renderTitle
      ? renderTitle()
      : title
  )

  return (
    <Section
      id={id}
      renderIcon={() => null}
      renderTitle={() => (
        <Fragment>
          {maybeRenderTitle()}
          {collapsibleSection && toggleCollapseSectionButton()}
        </Fragment>
      )}
    >
      {!isSectionCollapsed && (
        <ul className="side-bar-items-section__items-list">
          {renderChildren && renderChildren({toggle: () => {}})}
        </ul>
      )}
    </Section>
  )
}

ItemsSection.defaultProps = {
  collapsibleSection: false,
  id: null,
  renderChildren: null,
  renderTitle: null,
  expandedByDefault: false,
}

export default ItemsSection
